import React from "react";
import "../Styles/viewmore_diw.css";

const REGISTER_URL = "https://rzp.io/rzp/vanakkamhrdD54wgNvJ";

const MAP_URL =
  "https://www.google.com/maps?q=Chariot+Beach+Resort,+Chennai&output=embed";

const highlights = [
  { icon: "/Diwevent_icon1.png", text: "HR & Business Networking" },
  { icon: "/Diwevent_icon4.png", text: "Thought-Leadership Conversations" },
  { icon: "/Diwevent_icon2.png", text: "Diwali Celebration" },
  { icon: "/Diwevent_icon5.png", text: "Outstanding Workplace Stories" },
  { icon: "/Diwevent_icon3.png", text: "Fun, Laughter & Engagement" },
  { icon: "/Diwevent_icon6.png", text: "Community & Connections" },
];

const agenda = [
  { time: "4:00 - 4:30 PM", title: "Welcome & Networking Tea" },
  { time: "4:30 - 4:40 PM", title: "Opening & Welcome Address" },
  { time: "4:40 - 5:10 PM", title: "Outstanding Workplaces – Story" },
  { time: "5:10 - 5:30 PM", title: "The Future of People, Culture & Work" },
  { time: "5:30 - 7:00 PM", title: "Diwali Celebration, Fun & Games" },
  { time: "7:00 PM onwards", title: "Dinner & Open Networking" },
];

const ViewMoreDiw = () => {
  const handleRegister = () => {
    window.open(REGISTER_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* FIRST SECTION */}
      <section className="diw-viewer">

        <div className="diw-viewer-container">

          {/* LEFT */}
          <div className="diw-viewer-left">

            <h1 className="diw-viewer-title">
              Diwali Connect &  <br /> Foundation Day 2026
            </h1>

            <p className="diw-viewer-subtitle">
              “Building Outstanding Workplaces Culture, People & Purpose”
            </p>

            <div className="diw-viewer-info">

              <div className="diw-viewer-card">
                <img src="/assets/cal.png" alt="calendar" />
                <span>31st October, 2026 (Saturday)</span>
              </div>

              <div className="diw-viewer-card">
                <img src="/assets/Vec.png" alt="clock" />
                <span>4:00 PM - 7:00 PM</span>
              </div>

            </div>

            <div className="diw-viewer-card diw-viewer-location">
              <img src="/assets/loc.png" alt="location" />
              <span> Chariot Beach Resort, Chennai</span>
            </div>

            <button
              type="button"
              className="diw-viewer-btn"
              onClick={handleRegister}
            >
              <img src="/Evnt-tct.png" alt="ticket" />
              <span>Register Now</span>
            </button>

          </div>


          {/* RIGHT IMAGE */}
          <div className="diw-viewer-right">
            <img src="/Evnt-Diw-img.png" alt="conference" />
          </div>

        </div>

      </section>


      {/* SECOND SECTION - ABOUT EVENT */}
      <section className="diw-about">

        <div className="diw-about-container">

          {/* LEFT */}
          <div className="diw-about-left">

            <h2 className="diw-about-title">About the Event</h2>

            <p className="diw-about-text">
              Outstanding Workplaces brings together HR leaders, business leaders,
              founders, people professionals, and workplace enthusiasts for a special
              evening of celebration, connection, and meaningful conversations.
            </p>

            <p className="diw-about-text">
              As we celebrate Diwali and the Foundation Day of Outstanding Workplaces,
              the event is designed to bring people together beyond the workplace
              creating an environment to connect, celebrate, share experiences, build
              relationships, and inspire one another.
            </p>

            <p className="diw-about-text">
              Through engaging conversations around Culture, People &amp; Purpose, we
              will explore what it takes to create workplaces where people feel valued,
              connected, engaged, and empowered to thrive.
            </p>

          </div>


          {/* RIGHT CARD */}
          <div className="diw-about-right">

            <div className="diw-highlights-card">

              <h3 className="diw-highlights-title">Event Highlights</h3>

              <div className="diw-highlights-grid">
                {highlights.map((item, index) => (
                  <div className="diw-highlight-item" key={index}>
                    <div className="diw-highlight-icon">
                      <img src={item.icon} alt="" />
                    </div>
                    <span className="diw-highlight-text">{item.text}</span>
                  </div>
                ))}
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* THIRD SECTION - EVENT AGENDA */}
      <section className="diw-agenda">

        <div className="diw-agenda-container">

          <div className="diw-agenda-header">
            <h2 className="diw-agenda-title">Event Agenda</h2>
            <span className="diw-agenda-label">TIMELINE</span>
          </div>

          <div className="diw-agenda-list">
            {agenda.map((item, index) => (
              <div className="diw-agenda-item" key={index}>
                <span className="diw-agenda-time">{item.time}</span>
                <span className="diw-agenda-divider"></span>
                <span className="diw-agenda-name">{item.title}</span>
              </div>
            ))}
          </div>

        </div>

      </section>


      {/* FOURTH SECTION - MAP */}
      <section className="diw-map">

        <div className="diw-map-container">
          <div className="diw-map-frame">
            <iframe
              title="Chariot Beach Resort, Chennai"
              src={MAP_URL}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

      </section>
    </>
  );
};

export default ViewMoreDiw;